import { archivedSearchService } from '@/services/search-service';
import { useArchivedSearchIndex } from './use-archived-search-index';
import { useSearchCore, type SearchQuery } from './use-search-core';

// Full useSearch contract over the archived-docs index. See useArchivedSearchIndex for
// the index-bootstrap/readiness details this composes; useInfiniteArchivedSearch is the
// Archive page's entry point and picks between this (term present) and
// useArchivedBrowseSearch (term empty, paginated).
export const useArchivedSearch = (query: SearchQuery, enabled: boolean = true) => {
  const indexReady = useArchivedSearchIndex(enabled);
  const { data, stats, refetch, isInitialLoading } = useSearchCore(archivedSearchService, query, enabled);

  return {
    data,
    stats,
    refetch,
    isLoading: !indexReady || isInitialLoading,
  };
};
